import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Stitch, UserPasswordAuthProviderClient, GoogleRedirectCredential, UserPasswordCredential, FacebookRedirectCredential, RemoteMongoClient } from 'mongodb-stitch-browser-sdk'
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class PopularNewsService {


stichClient : any;

constructor() { 
      this.setUpMongoDbStich();
  }


  setUpMongoDbStich(){
    this.stichClient = Stitch.defaultAppClient;
  }

  getPopularNews(){
   // const db = this.stichClient.getServiceClient(RemoteMongoClient.factory,'mongodb-atlas');

    //const media = db.db('heroku_n5r1b6pp');
    const db = this.stichClient.getServiceClient(RemoteMongoClient.factory, 'mongodb-atlas').db('heroku_n5r1b6pp');
    //const db = this.stichClient.getServiceClient(RemoteMongoClient.factory, 'mongod-drbeen').db('drbeen');
    const query = { access : "freeForAll"};
    const options = { limit: 1 }

    //var allMedia = media.collection('media');
    /*this.stichClient.callFunction("getLatestLectures").then(result => {
      console.log(result) // Output: 7
    });
*/  

  //db.collection('settings').updateOne({owner_id: "Chandanc"}, {$set:{number:42}}, {upsert:true});

  // db.collection('settings').find().toArray()
    db.collection('media').find(query,options).toArray()
    .then(items => {
      console.log(JSON.stringify(items));
   // console.log(`Successfully found ${items.length} documents.`);
    //items.forEach(console.log);
    //return JSON.stringify(items);
  })
  .catch(err => console.error(`Failed to find documents: ${err}`));

    //db.collection('<COLLECTION>').find({owner_id: client.auth.user.id}, { limit: 100}).asArray()
    //console.log(allMedia);
  }

}

